import classNames from 'classnames';
import t from 'rcm-i18n';
import React, { FormEvent } from 'react';
import {VimeoVideo} from '@rcm/vimeo';

interface Props {
    className?: string;
    video?: VimeoVideo;
    [propName: string]: any;
}

const DownloadVideo = ({
    className = 'btn btn-primary',
    video,
    ...props
}: Props) => !!(video && video.id) &&
    <a className={classNames(className, 'download-video')}
            href={`/vimeo/video/${video.id}/download?width=${video.width}`}
            onClick={handleDownloadVideo}
            {...props}>
        {t('Download Video')}&nbsp;
    </a>;

export default DownloadVideo;

function handleDownloadVideo(e: FormEvent<HTMLElement>) {
    e.stopPropagation();
}
